import { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import React from 'react';
import { Typography } from '@mui/material';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_Zuwendungsantrag_Paths.json';
import { concat } from 'lodash';
import { Required } from '../../../../../../lib/validation/ValidationTypes';
const P = Schema.attributes;

const Erklaerung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<Typography variant="h3">Erklärungen</Typography>
			<CreateForm
				formStruc={formStruc}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};

export default Erklaerung;

const formStruc = [
	{
		fields: [
			{ ...P.Erklaerungen_Einwilligung_Art_7_EUDSGVO, type: 'checkbox', validation: [{ validateFunction: Required }] },
			{ ...P.Erklaerungen_Hinweis_Auf_Datenverarbeitung, type: 'checkbox', validation: [{ validateFunction: Required }] },
		],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
];

export const GetErklaerungFormStruc = () => {
	return concat(formStruc);
};
